import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../Shared/Loading/Loading';
import toast from 'react-hot-toast';
import Breadcrumb from '../../../Utilities/Breadcrumb';

const EditRole = () => {

    let { roleId } = useParams();
    const navigate = useNavigate();
    const [checked, setChecked] = useState([]);
    const [loading, setLoading] = useState(false);
    const [roleData, setRoleData] = useState({ name: '', permissionId: [] });
    const [errors, setError] = useState({ permissionId: '' });

    // setting permissions
    const permissions = [
        {
            name: 'dashboard-list'
        },
        {
            name: 'user-list'
        },
        {
            name: 'role-list'
        },
        {
            name: 'category-list'
        },
        {
            name: 'product-list'
        },
        {
            name: 'cart-list'
        },
        {
            name: 'order-list'
        },
    ]

    // getting specific category by id
    const { data: role, isLoading, refetch } = useQuery(['singleRoleinRole', roleId], () =>
        fetch(`${process.env.REACT_APP_SERVER_URL}role/${roleId}`, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`
            }
        })
            .then(res => {
                if (res.status === 401 || res.status === 401) {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('userId');
                    navigate('/login');
                    toast.error('Forbidden/Unauthorized access!');
                }
                return res.json();
            }))

    //getting data and set in state
    useEffect(() => {
        if (role?.success === true) {
            setRoleData({ name: role?.role.name });
            setChecked(role?.role.permissionsId)
        }
    }, [role]);

    // Add/Remove checked item from list
    const checkHandler = (event) => {
        var updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
    };

    // edit role
    const handleEditRole = (e) => {
        e.preventDefault();
        const postData = { ...roleData, permissionId: checked }

        if (postData.permissionId.length === 0) {
            setError({ ...errors, permissionId: 'You have to select atleast one permission.' })
        } else {
            setLoading(true);

            fetch(`${process.env.REACT_APP_SERVER_URL}role/${roleId}`, {
                method: 'PATCH',
                headers: {
                    'content-Type': 'application/json',
                    authorization: `Bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify(postData)
            })
                .then(res => {
                    if (res.status === 401 || res.status === 403) {
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('userId');
                        navigate('/login');
                        toast.error('Forbidden/Unauthorized access!');
                    }
                    return res.json();
                })
                .then(data => {
                    setLoading(false);
                    if (data.message && data.success === true) {
                        refetch();
                        setError({ ...errors, permissionId: '' });
                        toast.success(data.message);
                    }
                    if (data.message && data.success === false) {
                        toast.error(data.message);
                    }
                })
        }
    }

    // laoding
    if (isLoading) { return <Loading getHeight={'80vh'} /> }

    return (
        <form onSubmit={handleEditRole}>

            {/* ================== breadcrumb ==================== */}
            <Breadcrumb
                indexTitle={'Roles'}
                indexLink={'/dashboard/roles'}
                editPageTitle={`Edit [${role?.role.name}]`}
                editPageLink={`/dashboard/edit-role/${roleId}`}
                btnTitle={'Update Role'}
                loading={loading}
            />
            {/* ================================================== */}


            {/* main content */}
            <div className="row">
                <div className="col-md-12">
                    <div className="card py-4 px-3">

                        <h4>Edit Role</h4>
                        <hr />


                        <div className="row gx-5 gy-3">


                            <div className="col-sm-12">
                                <label htmlFor="name" className="form-label">Role Name<span className='text-danger'>*</span></label>
                                <input type="text" className="form-control" id="name" placeholder="User Name"
                                    disabled
                                    value={roleData?.name}
                                    required={!roleData.name}
                                    onChange={(e) => setRoleData({ ...roleData, name: e.target.value })} />
                                {
                                    errors.name && <p className='m-0 mt-2 text-danger'> {errors.name} </p>
                                }

                                <hr />
                            </div>

                            {/* permission view */}
                            <div className="permissions">
                                <div className="row gy-3">
                                    {
                                        permissions.map((permission, index) => <div key={index} className="col-md-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"
                                                    onClick={checkHandler}
                                                    checked={checked.find((item) => item === permission.name)}
                                                    value={permission.name} id={permission.name}
                                                />
                                                <label className="form-check-label" htmlFor={permission.name}>
                                                    {permission.name}
                                                </label>
                                            </div>
                                        </div>)
                                    }

                                    {
                                        errors.permissionId && <p className='m-0 mt-4 text-danger'> {errors.permissionId} </p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* main content */}
        </form>
    );
};

export default EditRole;